import { api } from "@/api/client";

// Mirrors Api::V1::EmailSignaturesController (the signed-in user's own).
export interface EmailSignature {
  id: number;
  name: string;
  body_html: string;
  default: boolean;
}

export interface SignatureInput {
  name?: string;
  body_html?: string;
  default?: boolean;
}

export async function fetchSignatures(): Promise<EmailSignature[]> {
  const { data } = await api.get<EmailSignature[]>("/email_signatures");
  return data;
}

export async function createSignature(input: SignatureInput): Promise<EmailSignature> {
  const { data } = await api.post<EmailSignature>("/email_signatures", { signature: input });
  return data;
}

export async function updateSignature(id: number, input: SignatureInput): Promise<EmailSignature> {
  const { data } = await api.patch<EmailSignature>(`/email_signatures/${id}`, { signature: input });
  return data;
}

export async function deleteSignature(id: number): Promise<void> {
  await api.delete(`/email_signatures/${id}`);
}
